"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_contact__us__or__customer__care(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.5 191.5"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e79fa6c4-a604-4c96-b886-24a0b0f5b0bf",
    x1: 32.25,
    y1: 87.05,
    x2: 59.07,
    y2: 113.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "67e890a7-8982-4499-b9ef-bf28f7bfb91b",
    x1: 150.93,
    y1: 89.34,
    x2: 179.78,
    y2: 118.19,
    xlinkHref: "#e79fa6c4-a604-4c96-b886-24a0b0f5b0bf"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b9cf74e0-5020-4430-89c5-07cab5b85acd",
    x1: 153.92,
    y1: 131.49,
    x2: 163.68,
    y2: 141.24,
    xlinkHref: "#e79fa6c4-a604-4c96-b886-24a0b0f5b0bf"
  })), /*#__PURE__*/React.createElement("title", null, "customer-care-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1368036-0faf-46c9-ba8a-cfe153ca87f3",
    "data-name": "customer-care-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "56049c51-50ad-40cd-9592-184d97bf982c",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24256000-bf42-4355-8df0-6380fa3ca99f",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a200944-e0aa-46ac-918f-6354bbb2dc69",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "947057b2-2312-41bf-95db-cc10276fe3e8",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a1b0523-8280-448a-aa23-4584aa46e7cd",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "59d48969-a66c-4ecf-a6c7-40a1849ae33a",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ec0a1b74-8e32-4c3c-b3da-e7b34347b43f",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "119f85e7-c1fc-4f5e-93ae-3ba4d085ef6d",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c2bac347-046f-4514-a3ac-0e6a59df16d3",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5a5f7a4c-eda9-4283-be81-4be16d8ba75d",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19eefea9-0c3a-45d6-acf6-e5c22f224563",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a6e0f41a-9ac8-45d8-8b23-36d674572c55",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c84d3392-f218-47ac-a4ba-16fdd1812012",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c0fa02ad-d9e8-463e-8285-eacd2a502a3d",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c55cf1bc-fc9c-4ac8-8a78-8b4b241319c4",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9583d081-4ba1-49ee-90b8-0740a13d0216",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0c8d818c-826e-485c-a764-e1a9ebe9260a",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a4fb1430-7049-4bda-8c41-94711e02647f",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "e3365b13-37af-4b4c-ba09-6231c87e95aa",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.13,79.75H47.75a0,0,0,0,1,0,0v64.07a0,0,0,0,1,0,0H37.13a16,16,0,0,1-16-16V95.75A16,16,0,0,1,37.13,79.75Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.55,128h0V96.1h0A5.55,5.55,0,0,0,16,101.65v20.8A5.55,5.55,0,0,0,21.55,128Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.75,79.75h4.07a4,4,0,0,1,4,4v56.07a4,4,0,0,1-4,4H47.75a0,0,0,0,1,0,0V79.75A0,0,0,0,1,47.75,79.75Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,128v.07a16,16,0,0,0,16,16H48v-2H37.38a16,16,0,0,1-16-16V128Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7,80h10.57a0,0,0,0,1,0,0v64.07a0,0,0,0,1,0,0H159.7a16,16,0,0,1-16-16V96A16,16,0,0,1,159.7,80Z",
    transform: "translate(313.71 223.82) rotate(-180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,128h0V96.1h0a5.55,5.55,0,0,1,5.55,5.55v20.8A5.55,5.55,0,0,1,170.27,128Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.73,80h4.07a4,4,0,0,1,4,4v56.07a4,4,0,0,1-4,4h-4.07a0,0,0,0,1,0,0V80A0,0,0,0,1,135.73,80Z",
    transform: "translate(279.28 223.82) rotate(-180)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,144.07h-4.07a4,4,0,0,1-4-4v-2a4,4,0,0,0,4,4h4.07Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.74 125.2 32.05 109.66 39.52 79.77 47.75 79.75 47.74 125.2",
    opacity: 0.2,
    fill: "url(#e79fa6c4-a604-4c96-b886-24a0b0f5b0bf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29,127.68l-16.94-16.54,6-30.26h0a16,16,0,0,1,11,15.76Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.2,
    fill: "url(#67e890a7-8982-4499-b9ef-bf28f7bfb91b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.89,112a4,4,0,0,1-4-4V80.15A56.12,56.12,0,0,0,95.83,24.09,55.31,55.31,0,0,0,55.61,41,56.9,56.9,0,0,0,39.78,80.15V108a4,4,0,1,1-8,0V80.15A65,65,0,0,1,49.85,35.48a63.24,63.24,0,0,1,46-19.39,64.13,64.13,0,0,1,64.06,64.06V108A4,4,0,0,1,155.89,112Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,16.09a63.24,63.24,0,0,0-46,19.39l-.5.53a4,4,0,0,0,.1,5.56l3,3c1-1.23,2-2.43,3.14-3.57A55.31,55.31,0,0,1,95.83,24.09a56,56,0,0,1,43.4,20.62l3-3a4,4,0,0,0,.11-5.53A63.87,63.87,0,0,0,95.83,16.09Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78,78.15v2A56.91,56.91,0,0,1,52.47,44.6l-.88-.88A56.89,56.89,0,0,0,39.78,78.15Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,78.15a55.76,55.76,0,0,0-11.78-34.32l-.88.88a55.79,55.79,0,0,1,12.66,35.44Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,22.09A55.11,55.11,0,0,0,51.59,43.71l.88.88c.49-.61,1-1.21,1.51-1.8S55.06,41.6,55.61,41A55.24,55.24,0,0,1,95.83,24.09c1,0,2.06,0,3.08.09l1,.08c.69,0,1.37.1,2.05.18l1.15.15c.62.08,1.24.17,1.86.27l1.18.21q.9.17,1.79.36l1.15.27c.6.15,1.2.31,1.8.47l1.07.3c.64.19,1.26.4,1.89.61l.91.31c.76.27,1.51.57,2.26.87l.47.18q1.39.58,2.74,1.24l.07,0q1.28.62,2.52,1.31l.6.35c.65.37,1.29.74,1.92,1.14l.71.46c.59.38,1.17.76,1.74,1.16l.72.51q.85.61,1.67,1.25l.66.52q.85.69,1.68,1.4l.54.47q.93.83,1.82,1.69l.3.29a56.49,56.49,0,0,1,4,4.44l.88-.88A56,56,0,0,0,95.83,22.09Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,127.68l-1.06,16,.24,0a16.19,16.19,0,0,0,9.88-6.92h0Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.2,
    fill: "url(#b9cf74e0-5020-4430-89c5-07cab5b85acd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,128v.07a16,16,0,0,1-16,16H143.8v-2h10.47a16,16,0,0,0,16-16V128Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,126.07V126a5.55,5.55,0,0,0,5.55-5.55v2a5.55,5.55,0,0,1-5.55,5.55v-1.93Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,144.07h4.07a4,4,0,0,0,4-4v-2a4,4,0,0,1-4,4H48Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.55,126.07V126A5.55,5.55,0,0,1,16,120.45v2A5.55,5.55,0,0,0,21.55,128v-1.93Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,168H96a4,4,0,0,1,0-8h27.85a28,28,0,0,0,28-28v-1.45a4,4,0,0,1,8,0V132A36,36,0,0,1,123.85,168Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.72,
    y: 155.78,
    width: 32,
    height: 16,
    rx: 8,
    ry: 8,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,166a7.59,7.59,0,0,0,.19-3,8,8,0,0,1-7.93,7H88A8,8,0,0,1,80,163,8,8,0,0,0,88,172h16a8,8,0,0,0,6.93-4",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9,168h12.95a36,36,0,0,0,36-36v-1.45s0-.07,0-.11a36,36,0,0,1-36,35.56H111.71",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }))))))))))))))))))))));
}

var _default = ic_contact__us__or__customer__care;
exports.default = _default;